import * as interfaces from "../../interfaces";
import { DslElement } from "../common";

export abstract class TransitionCondition extends DslElement implements interfaces.ITransitionCondition {
  isTransitionCondition: true = true as const;
  abstract toJson(): interfaces.ITransitionCondition;
  abstract toDsl(indent: number): string;
}
